import { db } from './firebase';
import { 
    collection, 
    getDocs, 
    addDoc, 
    updateDoc, 
    deleteDoc, 
    doc,
    getDoc
} from "firebase/firestore";

// Job Management
export const getAllJobsAdmin = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, "jobs"));
        const jobs = [];
        querySnapshot.forEach((doc) => {
            jobs.push({ id: doc.id, ...doc.data() });
        });
        return jobs;
    } catch (error) {
        console.error("Error loading jobs:", error);
        return [];
    }
};

export const addJob = async (jobData) => {
    try {
        const docRef = await addDoc(collection(db, "jobs"), {
            ...jobData,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            applicationCount: 0
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding job:", error);
        return { success: false, error: error.message };
    }
};

export const updateJob = async (jobId, jobData) => {
    try {
        const jobRef = doc(db, "jobs", jobId);
        await updateDoc(jobRef, {
            ...jobData,
            updatedAt: new Date().toISOString()
        });
        return { success: true };
    } catch (error) {
        console.error("Error updating job:", error);
        return { success: false, error: error.message };
    }
};

export const deleteJob = async (jobId) => {
    try {
        await deleteDoc(doc(db, "jobs", jobId));
        return { success: true };
    } catch (error) {
        console.error("Error deleting job:", error);
        return { success: false, error: error.message };
    }
};

// Blog Management
export const getAllBlogsAdmin = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, "blogs"));
        const blogs = [];
        querySnapshot.forEach((doc) => {
            blogs.push({ id: doc.id, ...doc.data() });
        });
        return blogs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } catch (error) {
        console.error("Error loading blogs:", error);
        return [];
    }
};

export const addBlog = async (blogData) => {
    try {
        const docRef = await addDoc(collection(db, "blogs"), {
            ...blogData,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding blog:", error);
        return { success: false, error: error.message };
    }
};

export const updateBlog = async (blogId, blogData) => {
    try {
        const blogRef = doc(db, "blogs", blogId);
        await updateDoc(blogRef, {
            ...blogData,
            updatedAt: new Date().toISOString()
        });
        return { success: true };
    } catch (error) {
        console.error("Error updating blog:", error);
        return { success: false, error: error.message };
    }
};

export const deleteBlog = async (blogId) => {
    try {
        await deleteDoc(doc(db, "blogs", blogId));
        return { success: true };
    } catch (error) {
        console.error("Error deleting blog:", error);
        return { success: false, error: error.message };
    }
};

// User Management
export const getAllUsers = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const users = [];
        querySnapshot.forEach((doc) => {
            users.push({ id: doc.id, ...doc.data() });
        });
        return users;
    } catch (error) {
        console.error("Error loading users:", error);
        return [];
    }
};

export const deleteUser = async (userId) => {
    try {
        await deleteDoc(doc(db, "users", userId));
        return { success: true };
    } catch (error) {
        console.error("Error deleting user:", error);
        return { success: false, error: error.message };
    }
};

// Dashboard Stats
export const getDashboardStats = async () => {
    try {
        const usersSnapshot = await getDocs(collection(db, "users"));
        const jobsSnapshot = await getDocs(collection(db, "jobs"));
        const blogsSnapshot = await getDocs(collection(db, "blogs"));
        
        let totalApplications = 0;
        jobsSnapshot.forEach((doc) => {
            totalApplications += doc.data().applicationCount || 0;
        });
        
        return {
            totalUsers: usersSnapshot.size,
            totalJobs: jobsSnapshot.size,
            totalBlogs: blogsSnapshot.size,
            totalApplications
        };
    } catch (error) {
        console.error("Error getting stats:", error);
        return {
            totalUsers: 0,
            totalJobs: 0,
            totalBlogs: 0,
            totalApplications: 0
        };
    }
};